import { render, staticRenderFns } from "./GrayCheck.vue?vue&type=template&id=6c78ed4b&"
import script from "./GrayCheck.vue?vue&type=script&lang=js&"
export * from "./GrayCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports